import React, { useEffect } from 'react';
import { reservationStore } from './reservation-store';

export const useReservationStore = (id: string) => {
  const [, render] = React.useState(0);
  reservationStore.onChange(id, () => {
    console.debug('[state]', btoa(JSON.stringify(reservationStore.state)));
    render((prev) => prev + 1);
  });

  // On load, initialise the guest details array with 1 entry as we always have a minimum of 1 adult, always.
  useEffect(() => {
    reservationStore.initialiseGuestDetails();
  }, []);
};
